import { initSentry } from "../../../shared/utils/sentry";
initSentry(import.meta.env.VITE_SENTRY_DSN);

import React from "react";
import "./components/System/installPromptEvents";
import ReactDOM from "react-dom/client";
import AppSelector from "./AppSelector.tsx";
import "./index.css";
import "./mobile.css";
import "./ios-fixes.css";
import "./android-fixes.css";

// Apply platform class before React renders so CSS takes effect from first paint
const ua = navigator.userAgent;
if (/android/i.test(ua)) {
  document.documentElement.classList.add("android");
} else if (/iphone|ipad|ipod/i.test(ua)) {
  document.documentElement.classList.add("ios");
}

import { setupGlobalErrorHandler } from "../../../shared/utils/errorSanitizer";

// Initialize global error handler for production security
setupGlobalErrorHandler();

// PWA recovery and service-worker code are not needed to paint or restore auth. Download
// both after load; the generated Workbox shell still owns offline behavior once registered.
window.addEventListener(
  "load",
  () => {
    void import("./pwa-init").then(({ initializePWA }) => initializePWA());
    void import("./serviceWorkerRegistration").then(({ register }) => register());
  },
  { once: true }
);

const root = document.getElementById("root")!;
const application = (
  <React.StrictMode>
    <AppSelector />
  </React.StrictMode>
);
if (root.dataset.prerendered === "story") {
  ReactDOM.hydrateRoot(root, application);
} else {
  ReactDOM.createRoot(root).render(application);
}
